export default __webpack_public_path__ + "static/media/cont8.daaae9a8.png";